import React, { useEffect, useState, useRef } from "react";
import {
  Button, Form, Col, Row, Modal, OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { createApproval, uploadFile } from "./nonRefSlice";
import InputNumber from "./../InputNumber";

import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl
} from "../../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  sizePerPageList,
  showDialog,
  useForceUpdate,
} from "../../../../utility";
import Select from "react-select";
import SVG from "react-inlinesvg";
import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from "@material-ui/icons/Image";
import moment from "moment";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  setSelected,
  selectSelected,
  selectTotalRecord,
  selectReasonParam,
  fetchReasonParam,
  fetchCustomer,
  fetchMaterial,
  selectDataMaterial,
  setApproval,
} from "./nonRefSlice";
import { selectUser } from "../../../../modules/Auth/_redux/authRedux";
import { NonRefTable } from "./NonRefTable";

import LoadingFetchData from "../LoadingFetchData";
export const NonReferencePage = (invoice) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const reasonParam = useSelector(selectReasonParam);
  const data = useSelector(selectData);
  const dataMaterial = useSelector(selectDataMaterial);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const user = useSelector(selectUser);
  const plants = user.plants.map((e) => {
    return e.plantCode;
  });
  const [reason, setReason] = useState("");
  const [selectCustomer, setSelectCustomer] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [remark, setRemark] = useState("");
  const [poNumber, setPoNumber] = useState(null);
  const [referenceInvoiceDate, setReferenceInvoiceDate] = useState("");
  const [pelapor, setPelapor] = useState("");
  const [requestDate, setRequestDate] = useState(
    new Date().getFullYear() +
    "-" +
    (new Date().getMonth() + 1) +
    "-" +
    new Date().getDate()
  );
  const forceUpdate = useForceUpdate();

  const dataParams = invoice.location.state.invoice;
  useEffect(() => {
    // Reset on first load
    dispatch(resetData());

    // Fetch data on first load
    dispatch(
      fetchReasonParam({
        paramGroupId: "REASON",
        pageNo: 1,
        pageSize: 20,
      })
    );
  }, [dispatch]);

  //checker rowRemark
  const checkValue = (value) => {
    let remarkRow = "";
    if (value.customerBlocked === true) {
      remarkRow = "Customer Block.";
    } else if (value.batchStatus === false) {
      remarkRow = "Invalid Batch Number, Please Contact PAM";
    } else if (value.blocked === true) {
      remarkRow = "Material Block. Please Contact PAM";
    } else if (value.materialExcluded === true) {
      remarkRow = "Material Block Exclusion. Please Contact PAM";
    } else if (value.crprgp === "N/A") {
      remarkRow = "CRRGP Block. Please Contact NDC RG Team";
    } else {
      remarkRow = "";
    }
    return remarkRow;
  };

  //
  const [tableDataMaterial, setTableDataMaterial] = useState(dataMaterial);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);

    const initData = dataMaterial.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
        blockRemark: checkValue(item),
        qty: 1,
        materialRemarks: "",
        availableQty: "1",
        returnUom: item.uom
      };
    });
    setTableDataMaterial(initData);
  }, [dataMaterial, pageSize, pageNo]);

  const reasonOptions = reasonParam.map((e) => {
    return {
      value: e.paramCode,
      label: e.paramValue,
    };
  });

  const getValueReason = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // Modal customer
  const [show, setShow] = useState(false);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const handleClose = () => {
    setCustomerCode("");
    setCustomerName("");
    setShowResultsCustomer(false);
    setShow(false);
    setTableDataCustomer("");
  };
  const handleShow = () => {
    setTableDataCustomer("");
    forceUpdate();
    setShow(true);
  };

  const [overlayStateCustomer, setOverlayStateCustomer] = React.useState(false);
  const [showResultsCustomer, setShowResultsCustomer] = React.useState(false);

  const [tableDataCustomer, setTableDataCustomer] = useState(data);

  useEffect(() => {
    // Add number
    const pageBefore = pageSize * (pageNo - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableDataCustomer(initData);
  }, [data, pageSize, pageNo]);

  const handleSearchCustomer = async () => {
    setOverlayStateCustomer(true);
    const params = {
      customerCode: customerCode,
      customerName: customerName,
      plant: plants.toString(),
      pageNo: pageNo,
      pageSize: pageSize,
    };
    await dispatch(fetchCustomer(params));
    setOverlayStateCustomer(false);
    setShowResultsCustomer(true);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setOverlayStateCustomer(true);

    const params = {
      customerCode: customerCode,
      customerName: customerName,
      plant: plants.toString(),
      pageNo: page,
      pageSize: sizePerPage,
    };
    await dispatch(fetchCustomer(params));
    setOverlayStateCustomer(false);
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  var rowEventsCustomer = {
    onClick: (e, row, rowIndex, cell) => {
      if (row.customerBlocked === true) {
        showDialog(row.blockRemark);
      } else {
        setSelectCustomer(row);
        setCustomerCode(row);
        setCustomerCode("");
        setCustomerName("");
        setTableDataCustomer("");
        setShow(false);
        forceUpdate();
      }
    },
  };

  // end fucntion modal

  // Modal Material
  const [showMaterial, setShowMaterial] = useState(false);
  const [materialCode, setMaterialCode] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [batch, setBatch] = useState("");
  const handleCloseMaterial = () => {
    setMaterialCode("");
    setMaterialName("");
    setBatch("");
    setShowMaterial(false);
    setTableDataMaterial([]);
  };
  const handleShowMaterial = () => {
    if (selectCustomer.length < 1) {
      return showErrorDialog("Please Select Customer !");
    }
    setShowMaterial(true);
  };
  const [onSelectAll, setOnSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [overlayStateMaterial, setOverlayStateMaterial] = React.useState(false);

  let notSelectableRows = [];

  const getNonSelectableRows = (payload) => {
    let nonSelectable = [];
    payload.map((value, index) => {
      if (value.customerBlocked === true) {
        nonSelectable.push(index);
      } else if (value.batchStatus === false) {
        nonSelectable.push(index);
      } else if (value.blocked === true) {
        nonSelectable.push(index);
      } else if (value.materialExcluded === true) {
        nonSelectable.push(index);
      } else if (value.crprgp === "N/A") {
        nonSelectable.push(index);
      }
    });

    return nonSelectable;
  };

  notSelectableRows = getNonSelectableRows(tableDataMaterial);

  const onSelectRow = {
    clickToSelect: true,
    mode: "checkbox",
    hideSelectAll: notSelectableRows.length > 0 ? true : false,
    nonSelectable: notSelectableRows,
    nonSelectableStyle: { backgroundColor: "gray" },
    onSelectAll: (status) => {
      setOnSelectAll(status);
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
          setSelectedRows(selectedRows);
        }
      }
      // return selectedRows;
    },
  };

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const StatusFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === true) {
      label = "Yes";
    } else if (cellContent === false) {
      label = "No";
    }

    return <span>{label}</span>;
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;

    if (notSelectableRows.includes(rowIndex)) {
      classes = "disabled-row-table";
    } else {
      classes = "enable-row-table";
    }

    return classes;
  };

  const handleDeleteRow = (uuid, dataTableOld, cell) => {
    const oldTable = dataTableOld;
    const idColumn = uuid;
    let tableDataNew = oldTable.filter(
      (value, index) => value.uuid !== idColumn
    );

    setSelectedRows(tableDataNew);
    setTableData(tableDataNew);
    forceUpdate();
  };

  const updateTableDataFromMaterialTable = () => {
    setTableData((tabledata) => [...tabledata, ...selectedRows]);
    setSelectedRows([]);
    setShowMaterial(false);
    setTableDataMaterial([]);
    setMaterialCode("");
    setMaterialName("");
    setBatch("");
    forceUpdate();
  };

  const handleSearchMaterial = async () => {
    let valid = false;
    if (materialCode === "" && batch !== "") {
      valid = true;
    } else if (batch === "" && materialCode !== "") {
      valid = true;
    } else if (batch !== "" && materialCode !== "") {
      valid = true;
    }

    if (!valid) {
      return showDialog("Please Insert Material or Batch Code First!");
    }
    setOverlayStateMaterial(true);
    const params = {
      customerCode: selectCustomer.customerCode,
      customerName: selectCustomer.customerName,
      distributionChannel: selectCustomer.distChannel,
      materialCode: materialCode,
      materialName: materialName,
      batch: batch.replace(/\s/g, ''),
      pageNo: pageNo,
      pageSize: pageSize,
    };
    console.log(params, "params")
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
  };

  const handleTableChangeMaterial = async (type, { page, sizePerPage }) => {
    setOverlayStateMaterial(true);

    const params = {
      customerCode: selectCustomer.customerCode,
      customerName: selectCustomer.customerName,
      distributionChannel: selectCustomer.distChannel,
      materialCode: materialCode,
      materialName: materialName,
      batch: batch.replace(/\s/g, ''),
      pageNo: page,
      pageSize: sizePerPage,
    };
    await dispatch(fetchMaterial(params));
    setOverlayStateMaterial(false);
  };
  const optionsMaterial = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  // end modal material

  const columnsCustomer = [
    { text: "No", dataField: "no" },
    { text: "Customer Code", dataField: "customerCode", align: "center" },
    { text: "Customer Name", dataField: "customerName" },
    {
      text: "Customer Block",
      dataField: "blockStatus",
      align: "center",
    },
    { text: "Sales Division", dataField: "salesDivision", align: "center" },
    { text: "Dist Channel", dataField: "distChannel", align: "center" },
    { text: "Address", dataField: "street1" },
    { text: "City", dataField: "city" },
    { text: "block Remark", dataField: "blockRemark" },
  ];
  const columnsMaterial = [
    { text: "uuid", dataField: "uuid", hidden: true },
    { text: "No", dataField: "no" },
    { text: "Material Code", dataField: "materialCode" },
    { text: "Material Name", dataField: "materialName" },
    { text: "Uom", dataField: "uom", align: "center" },
    {
      text: "Batch",
      dataField: "batch",
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: formatDate,
      align: "center",
    },
    {
      text: "Material Block",
      dataField: "blocked",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "Material Exclusion",
      dataField: "materialExcluded",
      formatter: StatusFormatter,
      align: "center",
    },
    {
      text: "CRPRGP",
      dataField: "crprgp",
      align: "center",
      formatter: StatusCrpFormatter,
    },
    {
      text: "NRA",
      dataField: "nra",
      formatter: StatusFormatter,
      align: "center",
    },

    {
      text: "Block Remarks",
      dataField: "blockRemark",
    },
  ];

  // move table func
  // const initData = data.map((item, index) => ({
  //   ...item,
  //   reason: reason,
  //   customerCode: customer.customerCode,
  //   plantCode: customer.plantCode,
  //   remark: remark,
  //   qty: 1,
  //   netPrice: 0,
  //   no: index + 1,
  //   uom: item.uom,
  //   requestDate: requestDate,
  //   poNumber: poNumber,
  //   pelapor: pelapor,
  //   referenceInvoiceDate: referenceInvoiceDate,
  //   dataParams: dataParams,
  //   remarkRow: checkValue(item),
  // }));


  const [btnDisabled, setBtnDisabled] = useState(false);


  const [rowIndexTable, setRowIndexTable] = useState(null);

  // function Remark
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].materialRemarks = e.target.value;
    setTableData(formatExtraData);
    // forceUpdate()
  };

  const remarkFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  console.log(tableData, "data")

  // const [docData, setDocData] = useState([]);

  const handleUpload = async (e, rowIndex, row, cell, formatExtraData) => {
    const file = e.target.files[0];
    const params = {
      file: file,
    };
    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        // const action = await showSuccessDialog(response.payload.data);

        const temp = tableData;
        temp[rowIndex].attachmentId = response.payload.data;
        temp[rowIndex].filename = file.name;
        setTableData(temp);
        forceUpdate();
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleDeleteFile = async (e, rowIndex) => {
    const temp = tableData;
    temp[rowIndex].attachmentId = null;
    temp[rowIndex].filename = null;
    forceUpdate();
  };

  // function Upload

  const uploadFormatter = (cell, row, rowIndex, formatExtraData) => {
    let render = (
      <div>
        <input
          type="file"
          onChange={(e) =>
            handleUpload(e, rowIndex, row, cell, formatExtraData)
          }
          style={{ color: "transparent", width: "91px" }}
          // accept="image/*"
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
    );

    if (row.attachmentId) {
      render = (
        <div className="filename-container">
          <div className="div-filename">{row.filename}</div>
          <a
            href={`${process.env.REACT_APP_API_URL}/return/attachment/${row.attachmentId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageIcon style={{ color: "#648DAE", marginRight: "5px" }} />
          </a>
          <DeleteIcon
            onClick={(e) => handleDeleteFile(e, rowIndex, formatExtraData)}
          />
        </div>
      );
    }

    // if (formatExtraData.reason == "132") {
    //   render = "cannot upload";
    // }

    return render;
  };

  const handleInputQtyChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].qty = e.target.value;
    setTableData(formatExtraData);
  };

  const inputQtyFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        defaultValue="1"
        value={row.qty}
      />
    );
  };

  const handleNetPriceChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].netPrice = e.target.value;
    setTableData(formatExtraData);
  };

  const netPriceFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        value={row.netPrice}
      />
    );
  };

  // UOM Render
  const getValueUom = (value, options) => {
    console.log(options.filter((val) => value === val.label));
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);

    const uom = selected[0];
    formatExtraData[rowIndex].returnUom = e.value;
    formatExtraData[rowIndex].qty =
      (formatExtraData[rowIndex].qty / uom.numerator) * uom.denumerator;
    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;
    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const handleDraft = () => {
    setBtnDisabled(true);

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.uom) {
      } else {
        value.uom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        qty: e.qty,
        netPrice: e.netPrice,
        uom: e.uom,
        sloc: e.sloc,
        uom: e.uom,
        remarkRow: e.materialRemarks,
        rayonType: e.rayonType,
        line: e.line,
      };
    });

    const params = {
      invoiceNo: dataParams,
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode,
      reasonCode: reason,
      transactionDate: referenceInvoiceDate,
      po: poNumber,
      dataSource: "NONREF",
      returnType: "NOREFNONMTKA",
      remark: remark,
      customerPODate: moment(requestDate).format("YYYY-MM-DD"),
      // referenceInvoiceDate: referenceInvoiceDate,
      draft: true,
      reporter: pelapor,
      items: items,
    };

    callApi(params);
  };

  const handleSave = () => {

    //checking attachment
    const attachmentChecker = [];
    tableData.map((val, index) => {
      if (val.attachmentId) {
      } else {
        attachmentChecker.push(index);
      }
    });

    const netPriceChecker = [];
    tableData.map((val, index) => {
      if (val.netPrice !== '0') {
      } else {
        netPriceChecker.push(index);
      }
    });
    console.log(netPriceChecker, "netPriceChecker")
    if (reason === "") {
      return showErrorDialog("Please Select Reason !");
    }

    if (reason !== "132" && attachmentChecker.length > 0) {
      return showErrorDialog("Please Upload Image !");
    }

    if (netPriceChecker.length > 0) {
      return showErrorDialog("Please Input Net Price First !");
    }

    if (reason === "") {
      return showErrorDialog("Please Select Reason First !");
    }
    if (referenceInvoiceDate === "") {
      return showErrorDialog("Please Select Reference Invoice Date First !");
    }

    if (remark === "") {
      return showErrorDialog("Please fill in the remarks !");
    }

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.uom) {
      } else {
        value.uom = value.uom;
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        qty: e.qty,
        netPrice: e.netPrice,
        uom: e.uom,
        sloc: e.sloc,
        uom: e.uom,
        remarkRow: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
        returnUom: e.returnUom
      };
    });

    const params = {
      invoiceNo: dataParams,
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode,
      reasonCode: reason,
      transactionDate: referenceInvoiceDate,
      po: poNumber,
      dataSource: "NONREF",
      returnType: "NOREFNONMTKA",
      remark: remark,
      customerPODate: moment(requestDate).format("YYYY-MM-DD"),
      draft: false,
      reporter: pelapor,
      items: items,
    };
    setBtnDisabled(true);
    callApi(params);
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createApproval(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/new-return/non-rtv");
        setBtnDisabled(false);
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog("Something went wrong!");
      setBtnDisabled(false);
    }
  };

  const optionsTable = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };
  const handleDelete = (e, row, rowIndex) => {
    const items = tableData.filter((item) => item.uuid !== row.uuid);
    console.log(items)
    setTableData(items);
  };
  const columns = [
    {
      text: "Action",
      dataField: "action",
      editable: false,

      formatter: (e, row, rowIndex) => {
        return (
          <OverlayTrigger
            overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
          >
            <div
              className="btn btn-icon btn-light btn-hover-danger btn-sm"
              onClick={() => handleDelete(e, row, rowIndex)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                />
              </span>
            </div>
          </OverlayTrigger>
        );
      },
    },
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      editable: false,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDate,
      editable: false,
    },
    {
      text: "NRA",
      dataField: "nra",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      editable: false,
    },
    {
      text: "Uom",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },
    {
      text: "Return Qty",
      dataField: "qty",
      sort: true,
      type: "number",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: inputQtyFormmater,
      editorRenderer: (
        editorProps,
        value,
        row,
        column,
        rowIndex,
        columnIndex
      ) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },
    {
      text: "Net Price",
      dataField: "netPrice",
      sort: true,
      type: "number",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: netPriceFormmater,
      editorRenderer: (
        editorProps,
        value,
        row,
        column,
        rowIndex,
        columnIndex
      ) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) =>
        uploadFormatter(cell, row, rowIndex, formatExtraData),
      formatExtraData: {
        reason: reason,
        tableData: tableData,
      },
    },
    {
      text: "Remark",
      dataField: "materialRemarks",
      formatter: remarkFormatter,
      editable: false,
      formatExtraData: tableData,

    },
  ];


  return (
    <>
      <Card>
        <CardHeader title="Non Reference"></CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>
                      Customer Code <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.customerCode}
                    />
                  </Col>
                  <Col sm={1}>
                    <Button variant="light" onClick={handleShow}>
                      <i className="fa fa-search"></i>
                    </Button>
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.customerName}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Division</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.salesDivision}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Distribution Channel</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.distChannel}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant Code</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={selectCustomer.plantCode}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Invoice Search</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control type="text" disabled value={dataParams} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Reporter</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      placeholder="Pelapor"
                      onChange={(e) => {
                        setPelapor(e.target.value);

                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Reason</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Select
                      options={reasonOptions}
                      value={getValueReason(reason, reasonOptions)}
                      placeholder="Select Reason..."
                      onChange={(e) => {
                        setReason(e.value);

                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Request Date</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="date"
                      defaultValue={
                        new Date().getDate() +
                        "-" +
                        (new Date().getMonth() + 1) +
                        "-" +
                        new Date().getFullYear()
                      }
                      onChange={(e) => {
                        setRequestDate(e.target.value);

                        forceUpdate();
                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Reference Invoice Date</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="date"
                      onChange={(e) => {
                        setReferenceInvoiceDate(e.target.value);

                      }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Remarks</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => {
                        setRemark(e.target.value);
                      }}
                      placeholder="Leave a comment here"
                      maxLength={100}
                      style={{ height: "80px" }}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Return Po Number</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => {
                        setPoNumber(e.target.value);

                      }}
                      placeholder="Leave a comment here"
                      maxLength={35}
                      style={{ height: "50px" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Row>
              <Col md="6" sm="6" lg="8">
                <Button
                  variant="primary"
                  className={`mr-5 mb-5`}
                  disabled={selectCustomer === "" ? true : false}
                  onClick={handleShowMaterial}
                >
                  Add Material
                </Button>
              </Col>
            </Row>
          </Form>

          {/* Table Add Material*/}
          {tableData.length > 0 && (
            <>
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="uuid"
                data={tableData}
                columns={columns}
                pagination={paginationFactory(optionsTable)}
                hover
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                })}
              />

              {/* Footer */}
              <Form>
                <Row>
                  <Col md="6" sm="6" lg="8">
                    <Button
                      variant="primary"
                      className="mr-5"
                      disabled={btnDisabled}
                      onClick={handleDraft}
                    >
                      Draft
                    </Button>
                    <Button
                      variant="success"
                      className="mr-5"
                      disabled={btnDisabled}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <Button
                      variant="secondary"
                      className="mr-5"
                      onClick={() => history.push("/new-return/non-rtv")}
                    >
                      Back
                    </Button>
                  </Col>
                </Row>
              </Form></>
          )}
        </CardBody>
      </Card>

      {/* customer */}
      <>
        <Modal show={show} onHide={handleClose} size="lg">
          <LoadingFetchData active={overlayStateCustomer} />
          <Modal.Header closeButton>
            <Modal.Title>Customer Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerCode(e.target.value);
                        }}
                        value={customerCode}
                        required
                        type="number"
                        placeholder="Costumer Code"
                      />
                    </Col>
                  </Form.Group>
                </Col>
                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                        }}
                        value={customerName}
                        required
                        type="text"
                        placeholder="Costumer Name"
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Button
                className="mb-5"
                variant="secondary"
                onClick={handleSearchCustomer}
              >
                Search
              </Button>
            </Form>
            {showResultsCustomer && (
              <BootstrapTable
                remote
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="customerId"
                data={tableDataCustomer}
                columns={columnsCustomer}
                pagination={paginationFactory(options)}
                onTableChange={handleTableChange}
                rowEvents={rowEventsCustomer}
                hover
              />
            )}
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </>
      {/*)}*/}

      {/* Add Material */}
      {/*{loading ? (
        <LayoutSplashScreen />
      ) : (*/}
      <Modal show={showMaterial} onHide={handleCloseMaterial} size="lg">
        <LoadingFetchData active={overlayStateMaterial} />
        <Modal.Header closeButton>
          <Modal.Title>Material Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      onChange={(e) => {
                        setMaterialCode(e.target.value);
                      }}
                      value={materialCode}
                      required
                      type="text"
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      type="text"
                      onChange={(e) => {
                        setBatch(e.target.value);
                      }}
                      value={batch}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      required
                      onChange={(e) => {
                        setMaterialName(e.target.value);
                      }}
                      value={materialName}
                      type="text"
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>

            <Button
              className="mb-5"
              variant="secondary"
              onClick={handleSearchMaterial}
            >
              Search
            </Button>
          </Form>
          {dataMaterial.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              keyField="uuid"
              data={tableDataMaterial}
              columns={columnsMaterial}
              pagination={paginationFactory(optionsMaterial)}
              onTableChange={handleTableChangeMaterial}
              selectRow={onSelectRow}
              rowClasses={rowClasses}
              hover
            />
          )}
        </Modal.Body>
        {dataMaterial.length > 0 && (
          <Modal.Footer>
            <Row className="mt-4">
              <Col>
                <Button
                  variant="success"
                  onClick={() => {
                    updateTableDataFromMaterialTable();
                  }}
                >
                  Choose
                </Button>
              </Col>
              <Col>
                <Button variant="outline-danger" onClick={handleCloseMaterial}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        )}
      </Modal>
      {/*)}*/}
    </>
  );
};
